import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ExternalLinkIcon, MailIcon, MapPinIcon, PartyPopperIcon } from 'lucide-react';
import { BadgeDivider } from './Badge';
type Show = {
  date: {
    weekday: string;
    monthDay: string;
  };
  time: string;
  venueName: string;
  venueUrl: string;
  mapUrl: string;
  city: string;
  thumbnail: string | null;
  markerBackingClass: string;
  markerLabel?: string;
  swatchClass: string;
};
const TWISTED_TIKI_MAP_URL = 'https://www.google.com/maps/dir//340+Corey+Ave,+St.+Pete+Beach,+FL+33706';
const PERIDIA_MAP_URL = 'https://www.google.com/maps/dir//4950+Peridia+Blvd+E,+Bradenton,+FL+34203';
const AMERICAN_LEGION_MAP_URL = 'https://www.google.com/maps/dir//American+Legion+Post+273+-+Madeira+Beach,+600+American+Legion+Dr,+Madeira+Beach,+FL+33708/@27.7930931,-82.7455018,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x88c2fc6a316a0661:0x9d617182192c7085!2m2!1d-82.7951634!2d27.8096528?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D';
const TWISTED_TIKI_LOGO = 'https://cdn.magicpatterns.com/uploads/nKMHg69DKAwqux1zav3jfG/Twisted2BTiki2Blogo2Bfloat2Bresized-1920w.webp';
const PERIDIA_LOGO = 'https://cdn.magicpatterns.com/uploads/i1DPYF4j9PYAVs6Ck6mpb3/Peridia_logo.webp';
const AMERICAN_LEGION_LOGO = 'https://cdn.magicpatterns.com/uploads/92p7X6AWgg7yVfxcUjyyMk/Am_Legion_273.png';
const SHOWS: Show[] = [{
  date: {
    weekday: 'Sat',
    monthDay: 'Sep 12'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Sep 25'
  },
  time: '6 PM–9 PM',
  venueName: 'Peridia Golf & Country Club',
  venueUrl: 'https://www.peridiagcc.net/',
  mapUrl: PERIDIA_MAP_URL,
  city: 'Bradenton, Florida',
  thumbnail: PERIDIA_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  swatchClass: 'bg-[#556b3c] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_#27351c]'
}, {
  date: {
    weekday: 'Sun',
    monthDay: 'Oct 11'
  },
  time: '2 PM–6 PM',
  venueName: 'American Legion Post 273',
  venueUrl: 'https://amleg273.com/',
  mapUrl: AMERICAN_LEGION_MAP_URL,
  city: 'Madeira Beach, Florida',
  thumbnail: AMERICAN_LEGION_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  markerLabel: 'Post 273',
  swatchClass: 'bg-[var(--vu-navy)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-cream)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Oct 24'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Nov 6'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Nov 13'
  },
  time: '6 PM–10 PM',
  venueName: 'American Legion Post 273',
  venueUrl: 'https://amleg273.com/',
  mapUrl: AMERICAN_LEGION_MAP_URL,
  city: 'Madeira Beach, Florida',
  thumbnail: AMERICAN_LEGION_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  markerLabel: 'Post 273',
  swatchClass: 'bg-[var(--vu-navy)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-cream)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Dec 26'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}];
export function Shows() {
  return <section id="shows" className="relative w-full overflow-hidden bg-[var(--vu-black)] px-5 py-20 grain" data-id="element-84" data-mp="pcw0ngwariot">
      <div className="relative z-10 mx-auto max-w-4xl text-center" data-id="element-85" data-mp="ke2k1flprbkf">
        <header className="relative overflow-hidden rounded-2xl border-2 border-[var(--vu-gold)]/75 bg-[var(--vu-black)] shadow-[6px_6px_0_0_var(--vu-navy)]" data-id="element-86" data-mp="fdn8mtkzse53">
          <img src="https://cdn.magicpatterns.com/uploads/dnMcD2rKQg8oCV2tvhE7Kc/VU_ConcertStage_Gemini.png" alt="Virtually Unknown performing together under concert stage lights" className="block aspect-video w-full object-contain" data-id="element-87" data-mp="ahpqqiu2yzq7" />
          <div className="absolute inset-x-0 top-0 h-[43%] bg-gradient-to-b from-[var(--vu-black)] via-[var(--vu-black)]/90 to-transparent" data-id="element-88" data-mp="1apcywu1i1yrv" />
          <div className="absolute inset-x-0 top-0 z-10 flex h-[38%] flex-col items-center justify-start px-4 pt-3 sm:pt-5" data-id="element-89" data-mp="1klzizgm04lsu">
            <p className="mb-1 font-cond text-[10px] uppercase tracking-[0.4em] text-[var(--vu-gold)] [text-shadow:0_2px_4px_rgba(0,0,0,0.95)] sm:mb-2 sm:text-xs" data-id="element-90" data-mp="1pdhjy4o0ymdt">
              On The Marquee
            </p>
            <h2 className="font-display text-3xl uppercase leading-none text-[var(--vu-cream)] [text-shadow:0_3px_8px_rgba(0,0,0,0.95)] sm:text-5xl" data-id="element-91" data-mp="1ybt71wpon21i">
              Upcoming Shows
            </h2>
            <BadgeDivider label="♬" data-id="element-92" data-mp="289z9qgjbcc7f" />
          </div>
        </header>

        <div className="mt-8 space-y-5 text-left" data-id="element-93" data-mp="8ypqrpj21b3g">
          {SHOWS.map((show, index) => <motion.article key={`${show.venueName}-${show.date.weekday}-${index}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="group flex w-full overflow-hidden border-2 border-[var(--vu-gold)]/65 bg-[var(--vu-cream)] text-[var(--vu-black)] shadow-[5px_5px_0_0_var(--vu-navy)] transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_0_0_1px_var(--vu-gold),0_12px_24px_rgba(224,163,37,0.22)]" data-id="element-94" data-mp="dx0zfwxm5fk3" data-mpi={index}>
              <div className="flex w-[29%] min-w-[88px] flex-col justify-center border-r-2 border-dashed border-[var(--vu-gold)]/75 bg-[var(--vu-navy)] px-2 py-5 text-center sm:w-[24%] sm:min-w-[142px] sm:px-5" data-id="element-95" data-mp="kt2hs5i9mfi1">
                <span className="font-cond text-[10px] font-semibold uppercase tracking-[0.2em] text-[var(--vu-gold)] sm:text-xs" data-id="element-96" data-mp="tmxqfnilio2f">
                  {show.date.weekday}
                </span>
                <span className="mt-1 font-display text-xl uppercase leading-[0.9] text-[var(--vu-cream)] sm:text-3xl" data-id="element-97" data-mp="13lws2m4y1jfx">
                  {show.date.monthDay}
                </span>
              </div>

              <div className="flex min-w-0 flex-1 items-center gap-4 px-3 py-5 sm:gap-7 sm:px-6" data-id="element-98" data-mp="1r775g5tq2ngr">
                <div className="min-w-0 flex-1" data-id="element-99" data-mp="1d7fwiji2bx9m">
                  <a href={show.venueUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-sm font-display text-2xl uppercase leading-none text-[var(--vu-navy)] transition-colors hover:text-[var(--vu-red)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-[var(--vu-red)] sm:text-3xl" data-id="element-100" data-mp="1i6sil21410b5">
                    <span className="truncate" data-id="element-101" data-mp="ze6qmstbptvu">{show.venueName}</span>
                    <ExternalLinkIcon className="h-4 w-4 shrink-0 text-[var(--vu-red)] sm:h-5 sm:w-5" aria-hidden="true" data-id="element-102" data-mp="kjto8xxw44gf" />
                  </a>
                  <div className="mt-3 space-y-1 font-cond text-[11px] uppercase tracking-[0.11em] text-[var(--vu-black)]/70 sm:text-xs" data-id="element-103" data-mp="1504l2d3shqls">
                    <p className="flex items-center gap-2" data-id="element-104" data-mp="11047svsfflgb">
                      <ClockIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-red)]" aria-hidden="true" data-id="element-105" data-mp="vzg8lmu1nyb0" />
                      {show.time}
                    </p>
                    <p className="flex items-center gap-2" data-id="element-106" data-mp="r2ptp2tz78r6">
                      <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-red)]" aria-hidden="true" data-id="element-107" data-mp="m2k7i26h6egh" />
                      {show.city}
                    </p>
                  </div>
                </div>

                <a href={show.mapUrl} target="_blank" rel="noopener noreferrer" className="group/map flex shrink-0 flex-col items-center rounded-sm transition-transform duration-300 ease-out hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-[var(--vu-red)]" aria-label={`Get directions to ${show.venueName}`} data-id="element-108" data-mp="da06ww6mhzt0">
                  <span className="relative block rounded-2xl hover:shadow-[0_0_0_2px_var(--vu-gold),0_0_16px_rgba(224,163,37,0.55)] group-hover/map:shadow-[0_0_0_2px_var(--vu-gold),0_0_16px_rgba(224,163,37,0.55)]" data-id="element-109" data-mp="3pbgoct3l4vob">
                    <span className={`block h-20 w-20 overflow-hidden rounded-2xl border-2 border-[var(--vu-gold)] sm:h-24 sm:w-24 ${show.markerBackingClass}`} data-id="element-110" data-mp="33yte4bj8jn4">
                      <span className={`absolute inset-0 rounded-2xl ${show.swatchClass}`} aria-hidden="true" data-id="element-111" data-mp="36miduknyyl7d" />
                      {show.thumbnail && <img src={show.thumbnail} alt={`${show.venueName} venue logo`} className="relative z-10 h-full w-full object-contain p-0.5" onError={event => {
                    event.currentTarget.style.display = 'none';
                  }} data-id="element-112" data-mp="3gcbrdr7o9ae9" />}
                    </span>
                    <span className="absolute -bottom-1.5 -right-1.5 z-20 flex h-6 w-6 items-center justify-center rounded-full border border-[var(--vu-cream)] bg-[var(--vu-black)] text-[var(--vu-gold)] shadow-sm sm:h-7 sm:w-7" data-id="element-113" data-mp="3m7ipa7xc8el2">
                      <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-114" data-mp="2yjre57nja7ld" />
                    </span>
                  </span>
                  {show.markerLabel && <span className="mt-1.5 font-cond text-[9px] uppercase tracking-[0.15em] text-[var(--vu-navy)]" data-id="element-115" data-mp="33ghrvobv8r3m">
                      {show.markerLabel}
                    </span>}
                </a>
              </div>
            </motion.article>)}
        </div>

        <p className="mt-6 font-cond text-xs uppercase tracking-[0.2em] text-[var(--vu-cream)]/45" data-id="element-116" data-mp="2fr6ywt0rc101">
          Full fall/winter schedule — more being added as they're booked
        </p>

        <div className="mt-10 border-2 border-[var(--vu-gold)]/40 bg-[var(--vu-navy)] p-8" data-id="element-117" data-mp="2cakkh9k7y3ce">
          <PartyPopperIcon className="mx-auto h-8 w-8 text-[var(--vu-gold)]" data-id="element-118" data-mp="27cslxwp2jiz8" />
          <p className="mt-3 font-body text-base leading-relaxed text-[var(--vu-cream)]/85" data-id="element-119" data-mp="239mckg6ntboj">
            We also play <strong className="text-[var(--vu-cream)]" data-id="element-120" data-mp="1yat1eueuhwrj">private events, weddings, and corporate parties.</strong>{' '}
            Reach out and we'll put together a quote for your date.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4" data-id="element-121" data-mp="1okzqlvmj1loc">
            <a href="mailto:nicksettemusic@gmail.com" className="inline-flex items-center gap-2 border-2 border-[var(--vu-black)] bg-[var(--vu-gold)] px-7 py-3 font-display uppercase tracking-wider text-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] transition-all hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[1px_1px_0_0_var(--vu-black)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" data-id="element-122" data-mp="1jm6nmx4v9d2f">
              <MailIcon className="h-4 w-4" data-id="element-123" data-mp="10z5uit09xp8f" />
              Booking Inquiry
            </a>
          </div>
        </div>
      </div>
    </section>;
}